import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'woCurrency', standalone: true })
export class CurrencyPipe implements PipeTransform {
  private readonly numberPipe: DecimalPipe;

  public constructor(@Inject(LOCALE_ID) localeId: string) {
    this.numberPipe = new DecimalPipe(localeId);
  }

  public transform(value?: number | null, unitPriceCurrency?: string | null): string {
    const formattedCost = this.numberPipe.transform(value, '1.2-2') || '-';
    return unitPriceCurrency
      ? `${ formattedCost } ${ unitPriceCurrency }`
      : '-';
  }
}
